import AuthWrap from './../../../assets/images/loginBackground-min.jpg';
import styles from '../styles/authWrap.module.scss';

function AuthWrapImage() {
  return <img className={styles.wrap} src={AuthWrap} alt='auth wrap'/>;
}

export default AuthWrapImage;
